import { render } from "./AppLabelNew.vue?vue&type=template&id=32c73179"
import script from "./AppLabelNew.vue?vue&type=script&lang=js"
export * from "./AppLabelNew.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__